import React, { useEffect } from 'react';
import { Nav } from './nav.tsx';
import { Footer } from './footer.tsx';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import i18next from 'i18next';
import '../css/faq.css';


export function FAQ() {
    const { lang } = useParams();
    const { t } = useTranslation();
    const baseURL = "https://www.parlaretail.com";
    useEffect(() => {
        if (lang) {
            i18next.changeLanguage(lang);
        }
    }, [lang]);

    // Explicitly typecast the returned object to an array of FAQSection
    const faqSections = t('faq.sections', { returnObjects: true }) as FAQSection[];

    return (
        <>
            <Helmet key={lang}>
                {/* General Meta */}
                <meta charSet="utf-8" />
                <meta http-equiv="X-UA-Compatible" content="IE=edge" />
                <title>{t('faq.meta.title')}</title>
                <meta name="description" content={t('faq.meta.description')} />
                <meta name="keywords" content={t('faq.meta.keywords')} />
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                {/* Open Graph */}
                <meta property="og:type" content="website" />
                <meta property="og:title" content={t('faq.meta.title')} />
                <meta property="og:description" content={t('faq.meta.description')} />
                <meta property="og:url" content={`${baseURL}/${lang}/`} />
                <meta property="og:image" content={`${baseURL}/img/sharing-image.jpg`} />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={t('faq.meta.title')} />
                <meta name="twitter:description" content={t('faq.meta.description')} />
                <meta name="twitter:image" content={`${baseURL}/img/sharing-image.jpg`} />

                {/* Hreflang for Language Versioning */}
                <link rel="alternate" hrefLang="en" href={`${baseURL}/en/`} />
                <link rel="alternate" hrefLang="es" href={`${baseURL}/es/`} />

                {/* Favicon */}
                <link rel="icon" type="image/png" href={`${baseURL}/img/parla-fav.png`} />
            </Helmet>
            <Nav />
            <div className="page">
                <div className="faq-section">
                    <div className="page-title">{t("faq.page_title")}</div>
                    <p className="page-subtitle center">{t("faq.page_subtitle")}</p>
                    <div className='center mb50'>
                        <section className="section-column-faq">
                            {faqSections.map((section, index) => (
                                <div className="card-faq" key={index}>
                                    <h2 className="section-title">{section.title}</h2>
                                    {section.questions.map((qa, qIndex) => (
                                        <>
                                            <div className="question" key={`q-${qIndex}`}>
                                                <strong>{qa.question}</strong>
                                            </div>
                                            <div className="answer" key={`a-${qIndex}`}>
                                                <p dangerouslySetInnerHTML={{ __html: qa.answer }} />
                                            </div>
                                        </>
                                    ))}
                                </div>
                            ))}
                        </section>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

interface FAQSection {
    title: string;
    questions: { question: string; answer: string }[];
}
